import { COL } from './columns/columns';

const COMMON_BODY_COLUMNS = ({
  closed,
  servicesDisabled,
}: {
  closed: boolean;
  servicesDisabled?: boolean;
}) => [
  COL.SERVICES({ disabled: servicesDisabled }),
  COL.ID(),
  COL.SPECIES(),
  COL.PRODUCT(),
  COL.LIFECYCLE_DATE({ closed }),
  COL.BAGGING_DATE(),
  COL.ORIGIN_MOISTURE(),
  COL.ON_FIELD_STOCK(),
  COL.TOTAL_EXTRACTED_WEIGHT(),
  COL.COUNTRYSIDE(),
  COL.ORGANIZATION(),
];

export const TABLE_COLUMNS = {
  SILOS_PRO: {
    VRR: [
      COL.NAME(),
      COL.VRR(),
      COL.INCONSISTENCIES(),
      ...COMMON_BODY_COLUMNS({ closed: false }),
      COL.ALERT(),
      COL.ACTION({ action: true, principalAction: 'share' }),
    ],
    WITHOUT_VRR: [
      COL.NAME(),
      COL.VRI(),
      COL.INCONSISTENCIES(),
      ...COMMON_BODY_COLUMNS({ closed: false }),
      COL.ALERT(),
      COL.ACTION({ action: true, principalAction: 'share' }),
    ],
    CLOSED: [
      COL.NAME(),
      ...COMMON_BODY_COLUMNS({ closed: true }),
      COL.ACTION({ action: true, principalAction: 'share' }),
    ],
  },
  SILOBAG: {
    ACTIVE: [
      COL.NAME(),
      ...COMMON_BODY_COLUMNS({ closed: false, servicesDisabled: true }),
      COL.ACTION({ action: true, principalAction: 'share' }),
    ],
    CLOSED: [
      COL.NAME(),
      COL.ID(),
      COL.SPECIES(),
      COL.PRODUCT(),
      COL.LIFECYCLE_DATE({ closed: true }),
      COL.BAGGING_DATE(),
      COL.ORIGIN_MOISTURE(),
      COL.ON_FIELD_STOCK(),
      COL.TOTAL_EXTRACTED_WEIGHT(),
      COL.COUNTRYSIDE(),
      COL.ORGANIZATION(),
      COL.ACTION({ action: true, principalAction: 'share' }),
    ],
    ARCHIVED: [
      COL.NAME(),
      COL.ID(),
      COL.SPECIES(),
      COL.BAGGING_DATE(),
      COL.INPUT_WEIGHT(),
      COL.COUNTRYSIDE(),
      COL.ORGANIZATION(),
      COL.ACTION({ action: false, principalAction: 'restore' }),
    ],
  },
};

export const TABLE_PINNED_COLUMNS = {
  alertas: 'right',
  acciones: 'right',
} as const;
